// extracted by mini-css-extract-plugin
export default {"search-recommended-results__item":"LxNvlc"};